// extracted by mini-css-extract-plugin
module.exports = {"logo":"Ie11Modal-module--logo--2VTwX"};